import { FC, PropsWithChildren } from 'react'

import IconButton from '../../../global/iconButton/IconButton'
import { CheckBox } from '../../../ui/v2/CheckBox/CheckBox'

import styles from './ButtonActionsBox.module.scss'

interface Props extends PropsWithChildren {
  isCheckBoxActive?: boolean
  isCheckBoxDisabled?: boolean
  onCheckBoxClick?: () => void
}

export const ButtonActionsBox: FC<Props> = (props) => {
  const { isCheckBoxActive, onCheckBoxClick, children, isCheckBoxDisabled } = props
  return (
    <div className={styles.buttonActionsBox}>
      <IconButton.New
        appearance='secondary'
        size='S'
        onClick={onCheckBoxClick}
        disabled={isCheckBoxDisabled}
      >
        <CheckBox type='edit' value={!!isCheckBoxActive} disabled={isCheckBoxDisabled} />
      </IconButton.New>
      {children}
    </div>
  )
}
